import { connect } from "react-redux";
import { Link } from "react-router-dom";

var CurrentUser = require("lib/account/CurrentUser");

var RosterActions = require("lib/actions/RosterActions");
var RosterSelectors = require("lib/selectors/RosterSelectors");
var DataRouting = require("lib/routing/DataRouting");

var OrgSearch = require("components/appdev/wizards/OrgSearch");
var PaginationControls = require("components/utility/PaginationControls");
var Spinner = require("components/utility/Spinner");

require("appdev/wizards/district_org_list.scss");

// Convert params to conditions
function paramsToConditions(params) {
	var conditions = _.pick(params,
		"orgID", "name", "nameExact", "orgAdminID", "page"
	);

	conditions.perPage = params.perPage || DataRouting.PER_PAGE;
	conditions.page = params.page || 1;

	return conditions;
}

@connect(
	(state, props) => ({
		// get whether the component is currently loading school orgs from the state
		isLoading: RosterSelectors.isLoadingDistrictOrgs({ state, key: 'index' }),
	}),

	(dispatch, props) => ({
		fetchDistrictOrgsPaginated: (params, page) => {
			return dispatch(RosterActions.fetchDistrictOrgsPaginated({
				conditions: paramsToConditions(params),
				embeds: ["district_org.primary_admin"],
				cache: true,
				page  // Specify the page number to fetch
			}))
		},

		// dispatches a selector to get school orgs with pagination.
		selectDistrictOrgs: (params) => {
			var conditions = paramsToConditions(params)
			return dispatch((dispatch, getState) => {
				return RosterSelectors.districtOrgsPaginated({ state: getState(), page: conditions.page, conditions })
			})
		},

		// dispatches a selector to get the total number of school orgs
		districtOrgsTotal: (params) => {
			var conditions = paramsToConditions(params)
			return dispatch((dispatch, getState) => {
				return RosterSelectors.districtOrgsTotal({ state: getState(), conditions })
			})
		}
	})
)

class DistrictOrgList extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = { currentPage: 1, paginatedDistrictOrgs: [], params: {} }
	}

	////////// HELPER FUNCTIONS //////////

	displayDistrictOrgName(districtOrg) {
		var route = "/district_orgs/" + districtOrg.id + "/details/controls";
		return (
			<Link to={ route } target="_blank">
				{ districtOrg.name } ({ districtOrg.state })
			</Link>
		);
	}
	displayAdminName(admin) {
		if (admin) {
			var route = "/users/" + admin.id + "/details";
			return (
				<Link to={ route }>
					{ admin.first_name } { admin.last_name }
				</Link>
			);			
		}
	}

	////////// STATE CHANGERS //////////

	// changes page from pagination component
	changePage(newPage) {
		var { params } = this.state;
		var newSearchParams = { ...params, page: newPage };

		// update the current page in state
		this.setState({ currentPage: newPage });

		// call selectDistrictOrgs with the updated search parameters
		var selectedDistrictOrgs = this.props.selectDistrictOrgs(newSearchParams);

		// check if any school orgs were returned
		if (_.size(selectedDistrictOrgs)) {
			// if there are school orgs, update the state with the new search parameters and the selected school orgs
			this.setState({ params: newSearchParams, paginatedDistrictOrgs: selectedDistrictOrgs });
		} else {
			// if there are no school orgs, fetch the paginated school orgs with the updated search parameters
			this.props.fetchDistrictOrgsPaginated(newSearchParams, newPage)
				.then(() => {
					// after fetching the school orgs, call selectDistrictOrgs again with the updated search parameters
					return this.props.selectDistrictOrgs(newSearchParams);
				})
				.then(selectedDistrictOrgs => {
					// update the state with the new search parameters and the selected school orgs
					this.setState({ params: newSearchParams, paginatedDistrictOrgs: selectedDistrictOrgs });
				});
		}
	}

	onSubmitSearch(params) {
		// call fetchDistrictOrgsPaginated with params and page number 1
		this.props.fetchDistrictOrgsPaginated(params, 1)
			// update local state
			.then(() => {
				this.setState({ params, currentPage: 1, paginatedDistrictOrgs: this.props.selectDistrictOrgs(params) })
			})
			// iff the promise is rejected, log the error to the console
			.catch((error) => {
				console.error("Error fetching school organizations", error);
			});
	}

	////////// RENDER METHODS //////////

	// controlls pagination
	renderPagination() {
		var { params, currentPage } = this.state
		var districtOrgsTotal = this.props.districtOrgsTotal(params) || 0

		if (districtOrgsTotal < 1 || this.props.isLoading) { return null }

		return (
			<PaginationControls page={currentPage} perPage={params.perPage}
				totalCount={districtOrgsTotal}
				onPageChange={this.changePage} />
		)
	}

	// handles rendering of a single district org
	renderDistrictOrg(districtOrg) {
		var admin = districtOrg.primary_admin;

		return (
			<tr key={districtOrg.id}>
				<td>
					{this.displayDistrictOrgName(districtOrg)}
					<br />
					{this.displayAdminName(admin)}
				</td>
				<td>
					<ul>
						<li>District Org ID: {districtOrg.id}</li>
						<li>Admin ID: {admin ? admin.id : "-"}</li>
					</ul>
				</td>
			</tr>
		);
	}

	// renders list of school orgs
	renderDistrictOrgList() {
		if (this.props.isLoading) {
			return <Spinner placeholder={true} scale={1.7} />
		} else {
			return (
				<div className="districtOrgList">
					<table>
						<tbody>
							{this.state.paginatedDistrictOrgs.map((districtOrg) => {
								return this.renderDistrictOrg(districtOrg)
							})}
						</tbody>
					</table>
				</div>
			)
		}
	}

	render() {
		return (
			<div className="districtOrgListContainer">
				<OrgSearch orgType='districtOrg' onSubmit={this.onSubmitSearch} />
				{this.renderPagination()}
				{this.renderDistrictOrgList()}
			</div>
		);
	}
};

DistrictOrgList.propTypes = PageStrictPropTypes({
});

module.exports = DistrictOrgList;


// WEBPACK FOOTER //
// ./modules/components/appdev/wizards/DistrictOrgList.js